module.exports = new __parcel__URL__("calendar-preview.cff0b145.svg").toString();